module.exports = __webpack_public_path__ + "img/ticketko_logo.5a0e4906.png";